export default ({ request }) => ({
  approvalCenterTodoListApi(data = {}) {
    return request({
      url: '/ecom/bflow/task/todo',
      method: 'POST',
      data,
    })
  },
  approvalCenterTodoApproveApi(data = {}) {
    return request({
      url: '/ecom/bflow/task/approve',
      method: 'POST',
      data,
    })
  },
  approvalCenterTodoRejectApi(data = {}) {
    return request({
      url: '/ecom/bflow/task/reject',
      method: 'POST',
      data,
    })
  },
})
